;$(document).ready(function(){
// 	switch product option
  $('input.swatch-element').on('change', function(){
    var optionValue = $(this).attr('data-value');
    var optionNumber = $(this).attr('name');
    $('#ProductSelect-' + optionNumber).val(optionValue);
  });
  
  function showRecoverPasswordForm() {
    $('#RecoverPasswordForm').show();
    $('#CustomerLoginForm').hide();
  }

  function hideRecoverPasswordForm() {
    $('#RecoverPasswordForm').hide();
    $('#CustomerLoginForm').show();
  }
  
  $('#HideRecoverPasswordLink').on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  $('#HideRecoverPasswordLink').on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });
  
  resetPasswordSuccess = function () {
    $('#ResetSuccess').show();
  };

  // Allow deep linking to recover password form
  if (location.hash == '#recover') {
    showRecoverPasswordForm();
  }
  

	// init slider on home page
	if($('#lookbook-slider').length){
		$('#lookbook-slider').slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 3000,
			arrows: true,
		});
	}

	// init picture previw
	if($(".fancybox-slide").length){
		$(".fancybox-slide").fancybox({
			padding: 0
		});
	}
  
  	//toggle thumbs on preview
  	$('.view-wrapper .swatch-element').hide();
  	$.each ($('.shopModal'), function(){
    	var currentColor = $(this).find('.color-wrapper input:checked').val();
      	$(this).find('.swatch-element[data-color="'+currentColor+'"]').show();
    });
  
    $('.color-wrapper .colorButton').on('click touch', function(){
      var currentColor = $(this).attr('data-value');
      var parent = $(this).parents('.modal-body');
      parent.find('.view-wrapper .swatch-element').hide();
      var previewIcons = parent.find('.swatch-element[data-color="'+currentColor+'"]');
      previewIcons.show();
      parent.find('.img-wrapper img').attr('src', previewIcons.first().find('img').attr('data-img-url'));
    });

	// edit feilds on account info page
	$('form .title-block .edit').on('click touch', function(){
		var form = $(this).parents('form');
		form.addClass('active');
		form.find('input, select').removeAttr('disabled').addClass('active');
	});
	// cancel edit feilds on account info page
	$('form .title-block .cancel').on('click touch', function(){
		var form = $(this).parents('form');
		form.removeClass('active');
		form.find('input, select').attr('disabled', 'disabled').removeClass('active');
	});

	//order history accordion
	$('.order-row .columns-wrapper').on('click touch', function(){
		var orderRow = $(this).parent('.order-row');
		if(orderRow.hasClass('active')){
			$(this).parents('.orders-wrapper').find('.order-row').removeClass('active').find('.details-wrapper').slideUp(200);
		}
		else{
			$(this).parents('.orders-wrapper').find('.order-row').removeClass('active').find('.details-wrapper').slideUp(200);
			orderRow.addClass('active').find('.details-wrapper').slideDown(200);
		}
	});

	// toogle filters
	$('#narrow-btn').on('click touch', function(){
		$(this).toggleClass('active').parents('.top-toolbar').find('.narrow-by').slideToggle(200);
        $('#sort-by-btn').removeClass('active').parents('.top-toolbar').find('.sort-by').slideUp(200);
	});
    $('#sort-by-btn').on('click touch', function(){
          $(this).toggleClass('active').parents('.top-toolbar').find('.sort-by').slideToggle(200);
	      $('#narrow-btn').removeClass('active').parents('.top-toolbar').find('.narrow-by').slideUp(200);
      });

	//open product quick view
	$('.quickAdd').on('click touch', function(event){
		event.preventDefault();
		var popupId = $(this).find('a').attr('href');
      	$(popupId + ' div[data-value="' + $(this).attr('data-color') + '"] input').click();
	});

	// header drop menu
//     $('.dropdown-toggle').click(function() {
//      var location = $(this).attr('href');
//      window.location.href = location;
//      return false;
//   });
  
  var is_menu_open = {};
  
  // hide large menu
function hideLargeMenu(){
	var item = $('.header .menu a');
    var menu = item.attr('data-menu');
  	is_menu_open = {};
    item.removeClass('active');
	$('.large-drop-menu').slideUp(200).stop(false, true);
}
  
  function open_menu(menu, item){
    hideLargeMenu();
    item.addClass('active');
    var topPosition = $('.header').height();
//     $('#dark-overlay').css('top', topPosition).slideDown(200);
    $('#' + menu).css('top', topPosition).slideDown(200);
    is_menu_open[menu] = true;
  }
  
  function collapse_menu(menu){
    hideLargeMenu();
    $('#dark-overlay').slideUp(200);
    is_menu_open[menu] = false;
  }
  
  function is_active(item){
  	return $(item).hasClass('active');
  }
  
  function get_menu_name(item){
  	return $(item).attr('data-menu');
  }
  
  function close_active_menu(){
  	var active_menu = $('.header .menu a.active');
    var menu = get_menu_name(active_menu);
    
    is_menu_open[menu] = false;
  }
  
  $('body').bind('mousemove', function(event){
    var classes = event.toElement.classList;
    regex = /(menu|dropdown-toggle|large-drop-menu|menu-link)/;
    
  	if(!regex.test(classes.value)){
    	hideLargeMenu();
    }
  })
  
  $('.header .menu a').bind('mouseover touch', function(event){
    var $this = $(this);
    var menu = get_menu_name($this);
    
      if(!!menu && !is_menu_open[menu]){
        open_menu(menu, $this);
      }
    event.preventDefault();
  });

	//inc and disc buttons
	$('.inc').on('click touch', function(){
		var inputField = $(this).siblings('input');
		inputField.val(parseInt(inputField.val()) + 1);
      	updateCart();
	});

	$('.disc').on('click touch', function(){
		var inputField = $(this).siblings('input');
		if(inputField.val() > 0) {
			inputField.val(parseInt(inputField.val()) - 1);
		}
      	updateCart();
	});
   	$('.cart-quantity-selector').on('blur', updateCart);

	// hide large menu and overlay
	$('#dark-overlay').on('click touch', function(){
		hideLargeMenu();
		$(this).slideUp(200);
	});
 

	//show search form
	$('.search-btn').on('click touch', function(event){
		event.preventDefault();
		$('.header .links ul').hide();
		$('#search-form').show().find('input').animate({
			width: '100%'
		},200);
	});
	$('.button').on('click touch', function(){
		hideLargeMenu();
		$('#search-form').hide().find('input').animate({
			width: 0
		},200);
		if(!isMobileWidth()){
			$('.header .links ul').show(200);
		}
		$('#dark-overlay').slideUp(200);
	});
  
	//hide search results
	$('#search-form input').on('blur', function(){
		hideLargeMenu();
		$('#search-form').hide().find('input').animate({
			width: 0
		},200);
		if(!isMobileWidth()){
			console.log('sdsadas');
			$('.header .links ul').show(200);
		}
		$('#dark-overlay').slideUp(200);
	});

	//hide large menu
	$(window).on('scroll', function(){
		hideLargeMenu();
		$('#dark-overlay').slideUp(200);
	});

	$('.large-drop-menu li.first, .narrow-by li.filter-title').on('click touch', function(event){
		if(isMobileWidth()){
			$(this).toggleClass('active').siblings('li').slideToggle(200);
		}
	});
	
	//toogle product params on mobile device
	$('.input-choose .label').on('click touch', function(){
		if(isMobileWidth()){
			$(this).toggleClass('active').siblings('ul').slideToggle(200);
		}
	});

	// view product image for mobile
	$('.top-params').on('click touch', function(){
		if( isMobileWidth()){
			var imgHref = $('.product-info .img-wrapper img').attr('data-zoom-image');
			$.fancybox.open({
				href: imgHref,
				padding: 0
			})
		}
	});
  
	// change image on product page
	$('.view-wrapper li').on('click touch', function(){
		var imgUrl = $(this).find('img').attr('data-img-url');
		$('.bigImg a img').attr('src', imgUrl);
	});
  
	// toggle image on quick view
  	$('.modal-body .view-wrapper .swatch-element').on('click', function(){
      var imgUrl = $(this).find('img').attr('data-img-url');
      $(this).parents('.modal-body').find('.img-wrapper img').attr('src', imgUrl);
    });

	//temporary------------------------------
	//show search results
	$('#search-form input').on('focus', function(){
		var topPosition = $('.header').height();
		$('#dark-overlay').css('top', topPosition).slideDown(200);
		$('#search-results').slideDown(200);
	});
	
});

function isMobileWidth(){
		var windowWidth = window.innerWidth
							|| document.documentElement.clientWidth
							|| document.body.clientWidth;
		return (windowWidth > 640) ? false : true;
	}

function updateCart(){
  $('#update-cart').click();
}

